// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"46cb7a70","258":"2ea008ed","732":"32e462c4","977":"3cb3a435"}[chunkId] + ".chunk.js";
};